module.exports = __webpack_public_path__ + "static/media/40.0812606e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/newWeatherIcons/40.svg
// module id = 2832
// module chunks = 3